<template>

  <v-container fluid class="pa-0" no-gutters>
    <v-card elevation="2" class="d-flex flex-column" style="min-height: 500px; max-height: 100vh;">
      <v-row class="fill-height" no-gutters>

        <!-- Apresentação -->
        <v-col cols="12" md="6">
          <v-card class="d-flex flex-column justify-center align-center text-center pa-8" flat rounded="0" height="100%"
            color="green-darken-3">
            <div>
              <h1 class="welcome-title mb-6">GAVI Gestão Clínica</h1>
              <LoginTitle />
            </div>
          </v-card>
        </v-col>

        <!-- Form de login -->
        <v-col cols="12" md="6">
          <v-card class="d-flex flex-column justify-center align-center pa-8" flat rounded="0" height="100%">
            <div class="w-100">
              <h2 class="login-title mb-8">IDENTIFICAÇÃO</h2>
              <LoginForm />
            </div>
          </v-card>
        </v-col>

      </v-row>
    </v-card>
  </v-container>

</template>

<script setup>
import LoginForm from '@/components/login/LoginForm';
import LoginTitle from '@/components/login/LoginTitle';
</script>
